var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgProductDefaultImage = function SvgProductDefaultImage(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.25 60.834c0-4.766 3.906-8.75 8.75-8.75 4.766 0 8.75 3.984 8.75 8.75 0 4.844-3.984 8.75-8.75 8.75a8.736 8.736 0 0 1-8.75-8.75Zm8.75-6.25a6.218 6.218 0 0 0-6.25 6.25c0 3.516 2.734 6.25 6.25 6.25a6.218 6.218 0 0 0 6.25-6.25c0-3.438-2.813-6.25-6.25-6.25Zm8.281-11.172.86 2.422H75c2.734 0 5 2.266 5 5v20c0 2.813-2.266 5-5 5H45c-2.813 0-5-2.188-5-5v-20c0-2.734 2.188-5 5-5h5.781l.86-2.422a3.706 3.706 0 0 1 3.515-2.578h9.61a3.706 3.706 0 0 1 3.515 2.578ZM45 48.334c-1.406 0-2.5 1.172-2.5 2.5v20c0 1.406 1.094 2.5 2.5 2.5h30c1.328 0 2.5-1.094 2.5-2.5v-20c0-1.328-1.172-2.5-2.5-2.5h-7.656l-1.406-4.14c-.157-.47-.626-.86-1.172-.86h-9.61c-.547 0-1.015.39-1.172.86l-1.406 4.14H45Z",
    fill: "#464B52"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgProductDefaultImage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/productDefaultImage.svg";